import { AUTH_BASE_PATH } from '@/constants';
import {
  SignInRequest,
  SignInResponse,
  SignUpRequest,
  SignUpResponse,
  VerifyEmailRequest,
  VerifyEmailResponse,
  ForgotPasswordRequest,
  ForgotPasswordResponse,
  ResetPasswordRequest,
  ResetPasswordResponse,
  RefreshTokenRequest,
  RefreshTokenResponse,
  SignOutResponse,
  MeResponse,
  SignInResponseSchema,
  SignUpResponseSchema,
  VerifyEmailResponseSchema,
  ForgotPasswordResponseSchema,
  ResetPasswordResponseSchema,
  RefreshTokenResponseSchema,
  SignOutResponseSchema,
  MeResponseSchema,
  SetPasswordRequest,
  SetPasswordResponse,
  SetPasswordResponseSchema,
  GetProvidersResponse,
  GetProvidersResponseSchema,
  UnlinkProviderResponse,
  UnlinkProviderResponseSchema,
  CheckUsernameResponse,
  CheckUsernameResponseSchema,
  CompleteOAuthRegistrationRequest,
  CompleteOAuthRegistrationResponse,
  CompleteOAuthRegistrationResponseSchema,
} from '@/types/auth';
import { apiRequest } from './client';

// Sign Up
export async function signUp(request: SignUpRequest): Promise<SignUpResponse> {
  const res = await apiRequest<unknown>({ url: `${AUTH_BASE_PATH}/sign-up`, method: 'POST', data: request });
  return SignUpResponseSchema.parse(res);
}

// Sign In
export async function signIn(request: SignInRequest): Promise<SignInResponse> {
  const res = await apiRequest<unknown>({ url: `${AUTH_BASE_PATH}/sign-in`, method: 'POST', data: request });
  return SignInResponseSchema.parse(res);
}

// Verify Email
export async function verifyEmail(request: VerifyEmailRequest): Promise<VerifyEmailResponse> {
  const res = await apiRequest<unknown>({ url: `${AUTH_BASE_PATH}/verify-email`, method: 'POST', data: request });
  return VerifyEmailResponseSchema.parse(res);
}

// Forgot Password
export async function forgotPassword(request: ForgotPasswordRequest): Promise<ForgotPasswordResponse> {
  const res = await apiRequest<unknown>({ url: `${AUTH_BASE_PATH}/forgot-password`, method: 'POST', data: request });
  return ForgotPasswordResponseSchema.parse(res);
}

// Reset Password
export async function resetPassword(request: ResetPasswordRequest): Promise<ResetPasswordResponse> {
  const res = await apiRequest<unknown>({ url: `${AUTH_BASE_PATH}/reset-password`, method: 'POST', data: request });
  return ResetPasswordResponseSchema.parse(res);
}

// Refresh Token
export async function refreshToken(request: RefreshTokenRequest): Promise<RefreshTokenResponse> {
  const res = await apiRequest<unknown>({ url: `${AUTH_BASE_PATH}/refresh-token`, method: 'POST', data: request });
  return RefreshTokenResponseSchema.parse(res);
}

// Sign Out
export async function signOut(): Promise<SignOutResponse> {
  const res = await apiRequest<unknown>({ url: `${AUTH_BASE_PATH}/sign-out`, method: 'POST' });
  return SignOutResponseSchema.parse(res);
}

// Me
export async function me(): Promise<MeResponse> {
  const res = await apiRequest<unknown>({ url: `${AUTH_BASE_PATH}/me`, method: 'GET' });
  return MeResponseSchema.parse(res);
}

// Set Password (for OAuth users)
export async function setPassword(request: SetPasswordRequest): Promise<SetPasswordResponse> {
  const res = await apiRequest<unknown>({ url: `${AUTH_BASE_PATH}/set-password`, method: 'POST', data: request });
  return SetPasswordResponseSchema.parse(res);
}

// Get Providers
export async function getProviders(): Promise<GetProvidersResponse> {
  const res = await apiRequest<unknown>({ url: `${AUTH_BASE_PATH}/providers`, method: 'GET' });
  return GetProvidersResponseSchema.parse(res);
}

// Unlink Provider
export async function unlinkProvider(provider: string): Promise<UnlinkProviderResponse> {
  const res = await apiRequest<unknown>({ url: `${AUTH_BASE_PATH}/providers/${provider}`, method: 'DELETE' });
  return UnlinkProviderResponseSchema.parse(res);
}

// Check Username Availability
export async function checkUsername(username: string): Promise<CheckUsernameResponse> {
  const res = await apiRequest<unknown>({
    url: `${AUTH_BASE_PATH}/check-username?username=${encodeURIComponent(username)}`,
    method: 'GET',
  });
  return CheckUsernameResponseSchema.parse(res);
}

// Complete OAuth Registration
export async function completeOAuthRegistration(request: CompleteOAuthRegistrationRequest): Promise<CompleteOAuthRegistrationResponse> {
  const res = await apiRequest<unknown>({
    url: `${AUTH_BASE_PATH}/oauth/complete-registration`,
    method: 'POST',
    data: request,
  });
  return CompleteOAuthRegistrationResponseSchema.parse(res);
}
